export enum SignalRMethods {
    LOG_SUBSCRIPTION = 'log_subscription',
    LOG_BATCH = 'log_batch',
    NEW_PRODUCT = 'new_product',
    PRODUCT_STATUS = 'product_status',
    NEW_NOTIFICATIONS = 'new_notifications',
    ACTION_UPDATE = 'action_update'
}